import React, { useContext, useEffect, useState } from "react";
import Layout from "../../../Layouts/Layout";
import "./LeaderBoard.scss";
import SearchSalesOrgLeaderboardReq from "../../../Requests/Organizations/SearchSalesOrgLeaderboardReq";
import OrgApi from "../../../API/OrgApi";
import {
	Accordion,
	AccordionDetails,
	AccordionSummary,
	CircularProgress,
	Pagination,
} from "@mui/material";
import { BiRightArrow, BiLeftArrow } from "react-icons/bi";
import { PaginationItem } from "@mui/material";
import anonUser from "./../../../assets/images/userGrey.png";
import rank1Image from "./assets/rank1.png";
import rank2Image from "./assets/rank2.png";
import rank3Image from "./assets/rank3.png";
import { DatePicker } from "antd";
import "antd/dist/antd.css";
import {
	MdExpandMore,
	MdChevronRight,
	MdChevronDown,
	MdChevronUp,
} from "react-icons/md";
import moment from "moment";
import { UserContext } from "../../../App";
import QuickDate from "../../../components/QuickDate";
import { useNavigate } from "react-router-dom";
import FiberCompanySelector from "./../../../components/FiberCompanySelector";
import {
	FaCalendar,
	FaCalendarAlt,
	FaChevronDown,
	FaFilter,
	FaTimes,
} from "react-icons/fa";
import { FaChevronUp, FaRegCalendar } from "react-icons/fa6";
import { CiCalendar } from "react-icons/ci";

const formatDateToISOString = (date) => {
	const year = date.getFullYear();
	const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
	const day = String(date.getDate()).padStart(2, "0");
	const hours = String(date.getHours()).padStart(2, "0");
	const minutes = String(date.getMinutes()).padStart(2, "0");
	const seconds = String(date.getSeconds()).padStart(2, "0");
	const milliseconds = String(date.getMilliseconds()).padStart(3, "0");

	// Concatenate without timezone offset
	return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}`;
};

const Index = () => {
	const user = useContext(UserContext);
	// receiving an error when using the getSalesRepLeaderboard API
	const [leaderBoardData, setLeaderBoardData] = useState([]);
	const [list, setList] = useState([]);
	const [loading, setLoading] = useState(false);
	const [selectedOrg, setSelectedOrg] = useState(null);
	const [installCompany, setInstallCompany] = React.useState("");
	const [expandedTeams, setExpandedTeams] = useState({});
	const [expandedMembers, setExpandedMembers] = useState({});
	const [showFilters, setShowFilters] = useState(false);

	const currentDay = new Date();
	const firstDayOfWeek = new Date(
		currentDay.setDate(currentDay.getDate() - ((currentDay.getDay() + 6) % 7)),
	);
	const lastDayOfWeek = new Date(
		currentDay.setDate(currentDay.getDate() - currentDay.getDay() + 7),
	);
	let from = new Date(firstDayOfWeek.setHours(0, 0, 0, 0));
	let to = new Date(lastDayOfWeek.setHours(23, 59, 59, 999));

	const [fromDate, setFromDate] = useState(formatDateToISOString(from));
	const [toDate, setToDate] = useState(formatDateToISOString(to));
	const [quickDate, setQuickDate] = useState("This Week");
	// const [selectedSalesRep, setSelectedSalesRep] = useState([]);
	const [currentPage, setCurrentPage] = useState(1);
	const [totalPages, setTotalPages] = useState(1);
	// const [expanded, setExpanded] = useState(false);
	const [rankedBy, setRankedBy] = useState("Sales");
	const [reset, setReset] = useState(1);
	const [activeTab, setActiveTab] = useState("Sold");
	const navigate = useNavigate();

	const toggleTeam = (teamId) => {
		setExpandedTeams((prev) => ({
			...prev,
			[teamId]: !prev[teamId],
		}));
	};

	const toggleMembers = (teamId) => {
		setExpandedMembers((prev) => ({
			...prev,
			[teamId]: !prev[teamId],
		}));
	};

	const getleaderBoardData = async () => {
		setLoading(true);
		const req = new SearchSalesOrgLeaderboardReq();
		let res = null;
		if (user.userType === "SalesOrgAdmin") {
			if (selectedOrg)
				req.salesOrgIds = Array.isArray(selectedOrg)
					? selectedOrg
					: [selectedOrg];
			else {
				req.salesOrgIds = [];
			}
		} else {
			if (installCompany?.length > 0) {
				req.fiberCompanyIds = installCompany;
			}
			req.salesOrgId = Array.isArray(selectedOrg)
				? selectedOrg[0]
				: selectedOrg;
		}
		// let from = new Date(new Date(fromDate).setHours(0, 0, 0, 0));
		req.from = fromDate !== "" ? fromDate : null;
		req.to = toDate !== "" ? toDate : null;
		req.rankedBy = rankedBy;
		// req.salesRepIds = selectedSalesRep;
		req.pagingParams.pageNumber = currentPage;
		req.pagingParams.pageSize = 1000;
		if (user.userType === "SuperAdmin") {
			console.log(req);
			res = await OrgApi.SearchSalesOrgLeaderboard(req);
		} else {
			req.salesRepId = user.id;
			req.salesOrgId = user.salesOrgId;
			res = await OrgApi.SearchSalesRepLeaderboard(req);
		}
		if (res?.status?.success) {
			console.log(res.data);
			setTotalPages(res.data.totalPages);

			setLeaderBoardData(res.data.entries);

			setLoading(false);
		}
	};

	useEffect(() => {
		setList([]);
		getleaderBoardData();
	}, [currentPage, rankedBy, fromDate, toDate, installCompany]);

	useEffect(() => {
		if (user.userType === "SuperAdmin") {
			const temp = [];
			leaderBoardData.map((data, index) => {
				let rank = index + 1;
				temp.push({
					...data,
					rank: <p className="font-bold text-lg">{"#" + rank}</p>,
					fiberCompany: (
						<p
							className="text-blue-500 underline cursor-pointer"
							onClick={() => {
								setSelectedOrg(data.salesOrg.id);
							}}
						>
							{data?.salesOrg?.name}
						</p>
					),
					noOfReps: data?.salesRepList?.length,
					AvgSales: Math.ceil(data.salesCount / data.salesRepList?.length),
					salesCount: data.salesCount,
					ds: data.ds,
					di: data.di,
					dc: data.dc,
					pi: data.pi,
					cs: data.cs,
					percentage:
						data.di === 0
							? "0%"
							: ((data.di / (data.di + data.dc)) * 100).toFixed(1) + "%",
					salesRepList:
						rankedBy === "Sales"
							? data.salesRepList.sort((a, b) => b.salesCount - a.salesCount)
							: data.salesRepList.sort((a, b) => b._DI - a._DI),
				});
			});

			if (rankedBy === "Sales") {
				temp.sort((a, b) => b.salesCount - a.salesCount);
			} else {
				temp.sort((a, b) => b.di - a.di);
			}

			setList(temp);
		} else {
			let temp = [];
			leaderBoardData.map((data, index) => {
				let rank = index + 1;
				temp.push({
					...data,
					rank: <p className="font-bold text-lg">{"#" + rank}</p>,
					salesRepName:
						data?.salesRep?.firstName + " " + data?.salesRep?.lastName,
					location: data?.salesRep?.location,
					salesCount: data?.salesCount,
					profileImage: data?.salesRep?.profileImage
						? data?.salesRep.profileImage.url
						: anonUser,
					_DS: data?.ds,
					_DI: data?.di,
					_DC: data?.dc,
					_PI: data?.pi,
					_CS: data?.cs,
					percentage:
						data.di === 0
							? "0%"
							: ((data.di / (data.di + data.dc)) * 100).toFixed(1) + "%",
				});
			});

			if (rankedBy === "Sales") {
				temp.sort((a, b) => b.salesCount - a.salesCount);
			} else {
				temp.sort((a, b) => b._DI - a._DI);
			}

			setList(temp);
		}
	}, [leaderBoardData]);

	useEffect(() => {
		// Initialize all teams as expanded by default when list changes
		if (list.length > 0) {
			const initialExpandedState = {};
			list.forEach((team, index) => {
				initialExpandedState[team.salesOrg?.id || index.toString()] = true;
			});
			setExpandedTeams(initialExpandedState);
		}
	}, [list]);

	const getRankImage = (rank) => {
		if (rank === 1) return rank1Image;
		if (rank === 2) return rank2Image;
		if (rank === 3) return rank3Image;
		return null; // No image for ranks other than 1, 2, and 3
	};
	const getMedalColor = (rank) => {
		if (rank === 1) return "medal-gold";
		if (rank === 2) return "medal-silver";
		if (rank === 3) return "medal-bronze";
		return "";
	};
	const [showQuickDate, setShowQuickDate] = useState(false);
	const [showDateRange, setShowDateRange] = useState(false);
	const { RangePicker } = DatePicker;

	return (
		<Layout>
			<div className="leaderboard_container">
				<h1 className="leaderboard-title">Leaderboard</h1>

				{/* Filters Section */}
				<div className="filter-section">
					<div className="filter-row">
						<div className="filter-group">
							{user.userType === "SuperAdmin" && (
								<div className="filter-dropdown">
									<button
										onClick={() => setShowFilters(!showFilters)}
										className="filter-button"
									>
										<FaFilter size={14} />
										Filter by company
										<FaChevronDown
											size={16}
											className={showFilters ? "rotate" : ""}
										/>
									</button>

									{showFilters && (
										<div className="filter-dropdown-content">
											{user.userType === "SuperAdmin" && (
												<div className="filter-item">
													<label>Fiber Company</label>
													<FiberCompanySelector
														setUser={setInstallCompany}
														companiesWithOfferTemplateOnly={true}
														disabled={false}
														multiple={true}
														placeholder="Select a Company"
														className="fiber_company_selector"
													/>
												</div>
											)}
										</div>
									)}
								</div>
							)}
							{/* Quick Date */}
							<div className="filter-dropdown">
								<button
									onClick={() => setShowQuickDate(!showQuickDate)}
									className="filter-button"
								>
									{quickDate || "Quick Date"}{" "}
									<FaChevronDown
										size={16}
										className={showQuickDate ? "rotate" : ""}
									/>
								</button>

								{showQuickDate && (
									<div className="filter-dropdown-content">
										<QuickDate
											selectQuickDate={quickDate}
											quickDate={quickDate}
											setQuickDateValue={setQuickDate}
											reset={reset}
											setFrom={setFromDate}
											setTo={setToDate}
											className="quick-date-selector"
										/>
									</div>
								)}
							</div>
							{/* Date Range */}
							<div className="filter-dropdown">
								<button
									onClick={() => setShowDateRange(!showDateRange)}
									className="filter-button"
								>
									{fromDate && toDate
										? `${new Date(fromDate).toLocaleDateString()} - ${new Date(
												toDate,
										  ).toLocaleDateString()}`
										: "Date Range"}{" "}
									<FaRegCalendar
										size={16}
										className={showDateRange ? "rotate" : ""}
									/>
								</button>

								{showDateRange && (
									<div className="filter-dropdown-content">
										<div className="date-picker-group">
											{/* From Date Picker */}
											<div className="date-picker-item">
												<label>From</label>
												<DatePicker
													format="YYYY-MM-DD"
													value={
														fromDate ? moment(fromDate.split("T")[0]) : null
													}
													onChange={(date) => {
														setFromDate(
															date
																? `${date.format("YYYY-MM-DD")}T00:00:00.000`
																: "",
														);
														if (!date) setToDate(""); // Reset toDate if fromDate is cleared
													}}
													disabledDate={(current) => {
														// Disable dates after the "toDate"
														if (toDate) {
															return (
																current &&
																current.isAfter(
																	moment(toDate.split("T")[0]),
																	"day",
																)
															);
														}
														return false;
													}}
													style={{ width: "100%" }}
												/>
											</div>

											{/* To Date Picker */}
											<div className="date-picker-item">
												<label>To</label>
												<DatePicker
													format="YYYY-MM-DD"
													value={toDate ? moment(toDate.split("T")[0]) : null}
													onChange={(date) => {
														setToDate(
															date
																? `${date.format("YYYY-MM-DD")}T23:59:59.999`
																: "",
														);
													}}
													disabledDate={(current) => {
														// Disable dates before the "fromDate"
														if (fromDate) {
															return (
																current &&
																current.isBefore(
																	moment(fromDate.split("T")[0]),
																	"day",
																)
															);
														}
														return false;
													}}
													style={{ width: "100%" }}
												/>
											</div>
										</div>
									</div>
								)}
							</div>

							<div className="tab-container">
								{["Sold", "Installed"].map((tab) => (
									<button
										key={tab}
										onClick={() => {
											setActiveTab(tab);
											setRankedBy(tab === "Sold" ? "Sales" : "Installs");
										}}
										className={`tab-button ${
											activeTab === tab ? "active" : ""
										}`}
									>
										{tab}
									</button>
								))}
							</div>
						</div>

						<div className="filter-row">
							<button
								onClick={() => {
									setRankedBy("Sales");
									setFromDate("");
									setToDate("");
									setQuickDate(""); // Reset the quick date filter
									setInstallCompany(""); // Reset the FiberCompanySelector filter
									setReset((prev) => prev + 1); // Trigger a reset
								}}
								className="reset-button"
							>
								<FaTimes size={14} />
								Clear all filter
							</button>
						</div>
					</div>
				</div>

				{loading ? (
					<div className="loading-container">
						<CircularProgress size={50} sx={{ color: "#41b6e6" }} />
					</div>
				) : user.userType === "SuperAdmin" ? (
					<div className="leaderboard-content">
						{/* Top 3 Teams */}
						<div className="top-teams">
							{list.slice(0, 3).map((team, index) => (
								<div key={index} className="team-card">
									<div className="team-header">
										<h3>{team.salesOrg?.name}</h3>
										<img
											src={getRankImage(index + 1) || "/placeholder.svg"}
											alt={`Rank ${index + 1}`}
											className="rank-image bg-transparent"
											style={{
												width: "50px",
												height: "50px",
												objectFit: "contain",
											}}
										/>
									</div>
									<div className="team-stats">
										<div className="stat-item">
											<p className="stat-label">Reps</p>
											<p className="stat-value">{team.noOfReps}</p>
										</div>
										<div className="stat-item">
											<p className="stat-label">Avg Sales</p>
											<p className="stat-value">{team.AvgSales}</p>
										</div>
										<div className="stat-item">
											<p className="stat-label">Total Sales</p>
											<p className="stat-value">{team.salesCount}</p>
										</div>
									</div>
								</div>
							))}
						</div>

						<div className="team-list">
							{/* Desktop Table Header - Only visible on desktop */}
							<div className="table-header">
								<div>Rank</div>
								<div>Team Name</div>
								<div>Reps</div>
								<div>Avg Sales</div>
								<div>Doors Sold</div>
								<div>Pending Installs</div>
								<div>Doors Installed</div>
							</div>

							{list.map((team, index) => (
								<div key={index} className="team-item">
									{/* Desktop view row */}
									<div
										className="team-header-row"
										onClick={() =>
											toggleMembers(team.salesOrg?.id || index.toString())
										}
									>
										<div className="rank">
											{expandedMembers[
												team.salesOrg?.id || index.toString()
											] ? (
												<FaChevronDown size={20} />
											) : (
												<MdChevronRight size={20} />
											)}
											{index + 1}
										</div>
										<div>{team.salesOrg?.name}</div>
										<div>{team.noOfReps}</div>
										<div>{team.AvgSales}</div>
										<div>{team.salesCount}</div>
										<div>{team.pi}</div>
										<div>{team.di}</div>
									</div>

									{/* Mobile view row */}
									<div
										className="mobile-team-row"
										onClick={() =>
											toggleMembers(team.salesOrg?.id || index.toString())
										}
									>
										<div className="team-name">
											<span className="chevron">
												{expandedMembers[
													team.salesOrg?.id || index.toString()
												] ? (
													<FaChevronDown size={16} />
												) : (
													<MdChevronRight size={16} />
												)}
											</span>
											{team.salesOrg?.name}
											<span className="team-reps">| {team.noOfReps} reps</span>
										</div>
										<div className="medal-container">
											<div className={`medal ${getMedalColor(index + 1)}`}>
												{index + 1}
											</div>
										</div>
									</div>

									{expandedMembers[team.salesOrg?.id || index.toString()] && (
										<div className="team-details">
											{/* Mobile view stats */}
											<div className="mobile-team-stats">
												<div className="stat-item">
													<p className="stat-label">Avg Sales</p>
													<p className="stat-value">{team.AvgSales}</p>
												</div>
												<div className="stat-item">
													<p className="stat-label">Doors Sold</p>
													<p className="stat-value">{team.salesCount}</p>
												</div>
												<div className="stat-item">
													<p className="stat-label">Pending Installs</p>
													<p className="stat-value">{team.pi}</p>
												</div>
												<div className="stat-item">
													<p className="stat-label">Doors Installed</p>
													<p className="stat-value">{team.di}</p>
												</div>
											</div>

											{/* Desktop view table header for members */}
											<div className="members-table-header">
												<div>Rank</div>
												<div>Sales Reps</div>
												<div>Doors Sold</div>
												<div>Pending Installs</div>
												<div>Doors Installed</div>
											</div>

											<div className="members-list">
												{(team.salesRepList || [])
													.filter(
														(rep) =>
															rep.salesRep.userType === "SalesRep" ||
															rep.salesRep.userType === "SalesOrgAdmin" ||
															rep.salesRep.userType === "SuperAdmin",
													)
													.map((member, memberIndex) => (
														<div key={memberIndex} className="member-item">
															{/* Desktop view member row */}
															<div className="desktop-member-row">
																<div>{memberIndex + 1}</div>
																<div className="member-info">
																	<div className="member-avatar">
																		<img
																			src={
																				member?.salesRep?.profileImage?.url ||
																				anonUser ||
																				"/placeholder.svg"
																			}
																			alt="Profile"
																		/>
																	</div>
																	<div className="member-name">
																		{member?.salesRep?.firstName +
																			" " +
																			member?.salesRep?.lastName}
																	</div>
																</div>
																<div>{member?.salesCount}</div>
																<div>{member?._PI}</div>
																<div>{member?._DI}</div>
															</div>

															{/* Mobile view member item */}
															<div className="mobile-member-item">
																<div className="mobile-member-header">
																	<div className="member-info">
																		<div className="member-avatar">
																			<img
																				src={
																					member?.salesRep?.profileImage?.url ||
																					anonUser ||
																					"/placeholder.svg"
																				}
																				alt="Profile"
																			/>
																		</div>
																		<div>
																			<div className="member-name">
																				{member?.salesRep?.firstName +
																					" " +
																					member?.salesRep?.lastName}
																			</div>
																			<div className="member-rank-text">
																				Rank # {memberIndex + 1}
																			</div>
																		</div>
																	</div>
																	<div className="medal-container">
																		<div
																			className={`medal ${getMedalColor(
																				memberIndex + 1,
																			)}`}
																		>
																			{memberIndex + 1}
																		</div>
																	</div>
																</div>
																<div className="mobile-member-stats">
																	<div className="stat-item">
																		<p className="stat-label">Doors Sold</p>
																		<p className="stat-value">
																			{member?.salesCount}
																		</p>
																	</div>
																	<div className="stat-item">
																		<p className="stat-label">
																			Pending Installs
																		</p>
																		<p className="stat-value">{member?._PI}</p>
																	</div>
																	<div className="stat-item">
																		<p className="stat-label">
																			Doors Installed
																		</p>
																		<p className="stat-value">{member?._DI}</p>
																	</div>
																</div>
															</div>
														</div>
													))}
											</div>
										</div>
									)}
								</div>
							))}
						</div>
					</div>
				) : (
					// Non-SuperAdmin (SalesRep or SalesOrgAdmin)
					<div className="leaderboard-content">
						{/* Top 3 SalesReps */}
						<div className="top-teams">
							{list.slice(0, 3).map((rep, index) => (
								<div key={index} className="team-card">
									<div className="team-header">
										<h3>{rep.salesRepName}</h3>
										<img
											src={getRankImage(index + 1) || "/placeholder.svg"}
											alt={`Rank ${index + 1}`}
											className="rank-image bg-transparent"
											style={{
												width: "50px",
												height: "50px",
												objectFit: "contain",
											}}
										/>
									</div>
									<div className="team-stats">
										<div className="stat-item">
											<p className="stat-label">Doors Sold</p>
											<p className="stat-value">{rep.salesCount}</p>
										</div>
										<div className="stat-item">
											<p className="stat-label">Pending</p>
											<p className="stat-value">{rep._PI}</p>
										</div>
										<div className="stat-item">
											<p className="stat-label">Doors Installed</p>
											<p className="stat-value">{rep._DI}</p>
										</div>
									</div>
								</div>
							))}
						</div>

						{/* Full SalesRep List */}
						<div className="team-list">
							{/* Desktop Table Header */}
							<div className="table-header">
								<div>Rank</div>
								<div>Sales Rep</div>
								<div>Doors Sold</div>
								<div>Pending Installs</div>
								<div>Doors Installed</div>
							</div>
							<div className="team-details">
								{list.map((rep, index) => (
									<div key={index} className="team-item">
										{/* Desktop Row */}
										<div className="team-header-row">
											<div className="rank">{index + 1}</div>
											<div className="member-info">
												<div className="member-avatar">
													<img
														src={rep.profileImage || anonUser}
														alt="Profile"
													/>
												</div>
												<div className="member-name">{rep.salesRepName}</div>
											</div>
											<div>{rep.salesCount}</div>
											<div>{rep._PI}</div>
											<div>{rep._DI}</div>
										</div>

										{/* Mobile Row */}
										<div className="mobile-member-item">
											<div className="mobile-member-header">
												<div className="member-info">
													<div className="member-avatar">
														<img
															src={rep.profileImage || anonUser}
															alt="Profile"
														/>
													</div>
													<div>
														<div className="member-name">
															{rep.salesRepName}
														</div>
														<div className="member-rank-text">
															Rank # {index + 1}
														</div>
													</div>
												</div>
												<div className="medal-container">
													<div className={`medal ${getMedalColor(index + 1)}`}>
														{index + 1}
													</div>
												</div>
											</div>

											<div className="mobile-member-stats">
												<div className="stat-item">
													<p className="stat-label">Doors Sold</p>
													<p className="stat-value">{rep.salesCount}</p>
												</div>
												<div className="stat-item">
													<p className="stat-label">Pending Installs</p>
													<p className="stat-value">{rep._PI}</p>
												</div>
												<div className="stat-item">
													<p className="stat-label">Doors Installed</p>
													<p className="stat-value">{rep._DI}</p>
												</div>
											</div>
										</div>
									</div>
								))}
							</div>
						</div>
					</div>
				)}

				<div className="pagination">
					<Pagination
						color="light"
						renderItem={(item) => (
							<PaginationItem
								components={{
									next: (props) => (
										<button {...props}>
											<BiRightArrow color="var(--color-icon)" />
										</button>
									),
									first: (props) => <button {...props}>First</button>,
									previous: (props) => (
										<button {...props}>
											<BiLeftArrow color="var(--color-icon)" />
										</button>
									),
								}}
								{...item}
								sx={{ color: "white" }}
							/>
						)}
						count={totalPages}
						page={currentPage}
						onChange={(e, v) => {
							setCurrentPage(v);
						}}
					/>
				</div>
			</div>
		</Layout>
	);
};

export default Index;
